(() => {
  class ApexProductMedia extends HTMLElement {
    connectedCallback() {
      if (this.updateStickyTop) return;
      this.header = document.querySelector('.site-header');
      this.updateStickyTop = () => {
        const height = this.getBoundingClientRect().height;
        if (!height) return;
        const headerHeight = this.header?.getBoundingClientRect().height || 70;
        // A tall column scrolls naturally until its bottom is visible, then
        // follows the page. Reviews never become trapped below the viewport.
        const top = Math.min(headerHeight + 20, window.innerHeight - height - 20);
        this.style.setProperty('--apex-media-sticky-top', `${Math.round(top)}px`);
      };
      if (typeof ResizeObserver === 'function') {
        this.observer = new ResizeObserver(this.updateStickyTop);
        this.observer.observe(this);
        if (this.header) this.observer.observe(this.header);
      }
      window.addEventListener('resize', this.updateStickyTop);
      this.updateStickyTop();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.updateStickyTop);
      this.observer = null;
      this.updateStickyTop = null;
    }
  }

  if (!customElements.get('apex-product-media')) {
    customElements.define('apex-product-media', ApexProductMedia);
  }
})();
